import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule, MatFormFieldControl } from "@angular/material/form-field";
import { SubscriptionComponent } from './subscription/subscription.component';
import { PaymentComponent } from './payment/payment.component';
import { StripeModule } from "stripe-angular"
import { ErrorInterceptor } from './helpers/error.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AngularFireAuthModule } from '@angular/fire/auth';
import { ProfileComponent } from './profile/profile.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { SelectCriteriaComponent } from './select-criteria/select-criteria.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { DropdownModule, MDBBootstrapModulesPro, MDBSpinningPreloader } from 'ng-uikit-pro-standard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from "@angular/common";
import { NgxSpinnerModule } from "ngx-spinner";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AddAdvertisementComponent } from './add-advertisement/add-advertisement.component';
import { PerpetualAddComponent } from './perpetual-add/perpetual-add.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { BasePaymentComponent } from './base-payment/base-payment.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './header/header.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
// import { DeviceDetectorModule } from 'ngx-device-detector';
import { AdvertisementsComponent } from './advertisements/advertisements.component';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { MessagingService } from './messaging.service';
import { MenuToggleService } from './side-nav.service';
import { AsyncPipe } from '@angular/common';
import { SettingsComponent } from './settings/settings.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { AddBuyGetActionComponent } from './add-buy-get-action/add-buy-get-action.component';
import { AgmCoreModule } from '@agm/core';
import { AutoComponent } from './auto/auto.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SideBarComponent } from './side-bar/side-bar.component';
import { SharedProfileComponent } from './shared-profile/shared-profile.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { DatePipe } from '@angular/common';
import { MySubscrationComponent } from './my-subscration/my-subscration.component';
import { CampusGreetingsComponent } from './campus-greetings/campus-greetings.component';
import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyPostcardComponent } from './my-postcard/my-postcard.component';
import { CrossChatComponent } from './cross-chat/cross-chat.component';
import { MinistryPostcardsComponent } from './ministry-postcards/ministry-postcards.component';
import { CommonHeaderComponent } from './common-header/common-header.component';
import { GetMyPostcardsComponent } from './get-my-postcards/get-my-postcards.component';
import { GetMyEventsComponent } from './get-my-events/get-my-events.component';
import { CreateEventComponent } from './create-event/create-event.component';
import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component';
import { AddPhotoGalleryComponent } from './add-photo-gallery/add-photo-gallery.component';
import { EnterpreneurResourceComponent } from './enterpreneur-resource/enterpreneur-resource.component';
import { BannerAdsListComponent } from './banner-ads-list/banner-ads-list.component';
import { AddBannerAdsComponent } from './add-banner-ads/add-banner-ads.component';
import { MyBannerPlansComponent } from './my-banner-plans/my-banner-plans.component';
import {MyAdsComponent} from './my-ads/my-ads.component';
import { UpdateEventsComponent } from './update-events/update-events.component';
import { FollowersListComponent } from './my-network/followers/followers-list.component';
import { MinistriesListComponent } from './my-network/affiliation/ministries-list.component';
import { CreateJobComponent } from './create-job/create-job.component';
import { MyJobsComponent } from './my-jobs/my-jobs.component';
import { HousingHubComponent } from './housing-hub/housing-hub.component';
import { MinistryCoverPhotoPipe } from './services/pipes/ministry-cover-photo.pipe';
import { MinistryProfilePhotoPipe } from './services/pipes/ministry-profile-photo.pipe';
import { UserProfilePhotoPipe } from './services/pipes/user-profile-photo.pipe';
import { MerchantCoverPhotoPipe } from './services/pipes/merchant-cover-photo.pipe';
import { MerchantProfilePhotoPipe } from './services/pipes/merchant-profile-photo.pipe';
import { AnalyticsComponent } from './analytics/analytics.component';
import { LeadsComponent } from './leads/leads.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SignInComponent,
    SubscriptionComponent,
    PaymentComponent,
    ProfileComponent,
    EmailVerificationComponent,
    UserRegistrationComponent,
    ChangePasswordComponent,
    SelectCriteriaComponent,
    PaymentSuccessComponent,
    AddAdvertisementComponent,
    PerpetualAddComponent,
    BasePaymentComponent,
    DashboardComponent,
    HeaderComponent,
    AdvertisementsComponent,
    SettingsComponent,
    AddBuyGetActionComponent,
    AutoComponent,
    SideBarComponent,
    SharedProfileComponent,
    MySubscrationComponent,
    CampusGreetingsComponent,
    UpdateProfileComponent,
    MyPostcardComponent,
    CrossChatComponent,
    MinistryPostcardsComponent,
    CommonHeaderComponent,
    GetMyPostcardsComponent,
    GetMyEventsComponent,
    CreateEventComponent,
    PhotoGalleryComponent,
    AddPhotoGalleryComponent,
    EnterpreneurResourceComponent,
    BannerAdsListComponent,
    AddBannerAdsComponent,
    MyBannerPlansComponent,
    MyAdsComponent,
    UpdateEventsComponent,
    FollowersListComponent,
    MinistriesListComponent,
    CreateJobComponent,
    MyJobsComponent,
    HousingHubComponent,
    MinistryCoverPhotoPipe,
    MinistryProfilePhotoPipe,
    UserProfilePhotoPipe,
    MerchantCoverPhotoPipe,
    MerchantProfilePhotoPipe,
    AnalyticsComponent,
    LeadsComponent
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgbTimepickerModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatInputModule,
    MatFormFieldModule,
    StripeModule.forRoot("pk_test_F63w3poxN6DSyrQcHvDfRe9C"),
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    GooglePlaceModule,
    MatAutocompleteModule,
    MatSelectModule,
    MDBBootstrapModulesPro.forRoot(),
    DropdownModule.forRoot(),
    NgbModule,
    CommonModule,
    BsDatepickerModule.forRoot(),
    NgxUiLoaderModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TabsModule,
    AngularFireMessagingModule,
    NgOtpInputModule,
    NgImageSliderModule,
    TimepickerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDuUMYOQbss-m0gFWxfxFKVsL4zJRLDWj0',
      libraries: ['places'],
    }),
    NgSelectModule
    // MatGoogleMapsAutocompleteModule
    // NgxLoadingModule.forRoot({})
    // AngularFireDatabaseModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }, MessagingService, MenuToggleService, AsyncPipe, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
